import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import ActivityGrid from '../component/ActivityGrid';
const Activity = () => {
  return (
    <>
      <h2 className={'TitleGrid'}>
        <Trans>Actividad</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <ActivityGrid />
    </>
  );
};

export default Activity;
